import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardBody, DashboardSVG, EmbedError } from '@ui/components';
import { Box, CircularProgress, Typography } from '@mui/material';
import { palette } from '@ui/styles/theme';
import { useQuickSightEmbed } from '@core/hooks';
import { DASHBOARD_NAMES } from '@core/constants/quicksight';

export default function Dashboards () {
    const { t } = useTranslation();
    const { loading, error, containerRef, retry } = useQuickSightEmbed(DASHBOARD_NAMES.METRICS);

    return (
        <Box display='flex' flexDirection='column' justifyContent='center' width='100%' marginRight='2rem'>
            <Box style={{ borderRadius: '0.3077rem' }}>
                <Card>
                    <Box
                        display='flex'
                        alignItems='center'
                        style={{ height: '4.4615rem' }}>
                        <Box className='svgIcon'>
                            <DashboardSVG customStroke={palette.secondary.main} strokeWidth='1.3' />
                        </Box>
                        <Typography variant='pageHeaderTitle' className='headerText'>{t('dashboards.title')}</Typography>
                    </Box>
                </Card>
            </Box>
            <Card>
                <CardBody fit>
                    {loading && (
                        <Box minHeight="30.769rem" display="flex" alignItems="center" justifyContent="center">
                            <CircularProgress />
                        </Box>
                    )}

                    {!loading && error && (
                        <EmbedError onRetry={retry} />
                    )}

                    {!loading && !error && (
                        <div ref={containerRef} />
                    )}
                </CardBody>
            </Card>
        </Box>
    );
}
